export function removeObjectDuplicates(array: any[], key: string) {
    const seen = new Set();

    return array.filter(item => {
        const value = item[key];

        if (seen.has(value)) {
            return false;
        }

        seen.add(value);
        return true;
    });
}